/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-31 10:48:34
 * @LastEditors: Jack Deng
 * @LastEditTime: 2022-06-08 13:03:07
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductsLinkProduct/index.tsx
 */
import { Button, Skeleton } from '@/src/components/Antd';
import Warning from '@/src/components/Antd/Modal/WarningModal';
import TypedProductsSelection, {
  SelectionType,
} from '@/src/constrains/ProductsSelection/ProductsSelection'; //  SelectionType,
import RouteBlock from '@/src/constrains/RouterBlock/RouterBlock';
import { EnumMultiLanguageType } from '@/src/constrains/SalesChannelMultiLanguageSelect';
import SalesChannelHeader from '@/src/layout/SalesChannelEditorLayout/HomeLayout/SalesChannelHeader';
import { getI18nFromGeneral } from '@/src/tools/tools';
import { EnumProductProperty } from '@/src/types/common/product';
import React from 'react';
import { useParams } from 'react-router-dom';
import SalesChannelHOC, {
  SelectHOC,
} from 'src/constrains/SalesChannelHOC/SalesChannelHOC';
import {
  FlashSale,
  LinkProduct,
  Options,
  Price,
  Stock,
  SubscriptionBuy,
} from '../Components';
import { SecondaryOptions, ServiceDetail } from './Components';
import PromotionTag from './Components/PromotionTag';
import Logistic from './Components/VirtualProductLogisticMethod';
import VirtualStock from './Components/VirtualStock';
import { useService } from './service/service';
import styles from './style.module.less';

import { Form } from 'src/components/Antd';
import { useI18n } from 'src/hooks/useRouterChange';
import {
  isUserValid,
  salesChannelResourceNameGenerator,
} from 'src/tools/getUserInfo';
import { i18nGet } from 'src/tools/tools';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from 'src/types/common/resources';

const permissions = (saleChannelUuid) => {
  const canViewDetails = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        uuid: saleChannelUuid,
        category: EnumCategory.SalesChannelProduct,
        subCategory: EnumSubCategory.ChannelProduct,
        operation: EnumOperation.view_product_details_page,
      }),
    ],
  });
  const canCreate = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        uuid: saleChannelUuid,
        category: EnumCategory.SalesChannelProduct,
        subCategory: EnumSubCategory.ChannelProduct,
        operation: EnumOperation.add_edit_product,
      }),
    ],
  });
  const canDelete = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        uuid: saleChannelUuid,
        category: EnumCategory.SalesChannelProduct,
        subCategory: EnumSubCategory.ChannelProduct,
        operation: EnumOperation.delete_product,
      }),
    ],
  });
  return { canViewDetails, canCreate, canDelete };
};

function SalesChannelProductsLinkProduct() {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    currency,
    productService,
    currencyInfo,
    optionsForMultiLang,
    isOnPrimaryLanguage,
    deleteOptionIndex,
    salesChannelProductUuid,
    deleteModalVisible,
    addModalVisible,
    generalInfo,
    products,
    options,
    isLoading,
    delOption,
    deleteProduct,
    handleAddOption,
    handleCloneOptions,
    handleDeleteOption,
    handleChangeLabel,
    handleMLChangeLabel,
    handleMLChangeValue,
    handleAddTag,
    handleAddProduct,
    handleDeleteTag,
    handleChangeProductRrp,
    handleHideOptionDelete,
    handleChangeListPrice,
    handleGoBack,
    handleChangeVisibility,
    handleDelete,
    handleChangeVariant,
    handleShowWarning,
    handleHideWarning,
    handleHide,
    handleShowAdd,
    handleSubmit,
    vailidateLabel,
    handleChangePlaceholder,
    handleChangeServiceOptions,
    handleChangeTitle,
    handleOnDetailsTcChange,
    termsAndConditionList,
    handleLogisticNotifyChange,
    handleLogisticEmailChange,
    handleLogisticSmsChange,
    productLogistics,
    hasModified,
    salesChannelCurrency,
    flashSaleProducts,
    subscriptionBuyProducts,
    allPromotionTags,
    handleOnAllPromotionTags,
    form,
  } = useService();
  //console.log('allPromotionTags', allPromotionTags);
  const services = products.filter((i) => i.productType === 'Service');
  const isVirtual =
    products.length > 0 &&
    (products[0]?.productType === 'GiftCard' ||
      products[0]?.productType === 'Service');
  const isPhysical =
    products.length > 0 &&
    products[0]?.productType !== 'GiftCard' &&
    products[0]?.productType !== 'Service';

  const { saleChannelUuid }: { saleChannelUuid: string } = useParams();
  const { canViewDetails, canCreate, canDelete } = permissions(saleChannelUuid);

  return (
    <div className={styles.container}>
      <RouteBlock
        onConfirm={(f) => f()}
        okText={getI18nFromGeneral('general.commonHeader.discard_text')}
        active={hasModified}
        title={getI18nFromGeneral('general.commonHeader.discard_header')}
        content={getI18nFromGeneral('general.commonHeader.discard_content')}
      />
      <Form form={form} name='SalesChannelProduct'>
        <div className={styles.header}>
          <SalesChannelHeader
            showVisibility={true}
            visible={generalInfo.visible}
            hasModified={hasModified && products.length !== 0}
            customType={EnumMultiLanguageType.SalesChannelProduct}
            salesChannelUuid={'saleChannelUuid'}
            hideMultiLanguage={salesChannelProductUuid === 'null'}
            disabledDelete={salesChannelProductUuid === 'null'}
            title={generalInfo.salesChannelName}
            description={canViewDetails && generalInfo.productName}
            submit={canCreate && handleSubmit}
            onDiscard={handleGoBack}
            onGoBack={handleGoBack}
            onDelete={canDelete && handleShowWarning}
            onChangeVisibility={canCreate && handleChangeVisibility}
          />
        </div>
        {canViewDetails ? (
          <div className={styles.content}>
            {isOnPrimaryLanguage && (
              <>
                <Skeleton active loading={isLoading}>
                  <LinkProduct
                    products={products}
                    disabled={!canCreate}
                    onDelete={deleteProduct}
                    onClickLnkBtn={handleShowAdd}
                    getI18n={getI18n}
                  />
                </Skeleton>
                {products.length !== 0 && (
                  <>
                    <Price
                      isVirtual={isVirtual}
                      currencyInfo={currencyInfo}
                      currency={currency}
                      products={products}
                      disabled={!canCreate}
                      onChangeProductRrp={handleChangeProductRrp}
                      onChangeListPrice={handleChangeListPrice}
                      getI18n={getI18n}
                      salesChannelCurrency={salesChannelCurrency}
                    />
                    <FlashSale data={flashSaleProducts} />
                    {products.length > 1 ? (
                      <Options
                        products={products}
                        options={options}
                        disabled={!canCreate}
                        onAddOption={handleAddOption}
                        onDeleteOption={handleDeleteOption}
                        onChangeLabel={handleChangeLabel}
                        onAddTag={handleAddTag}
                        onDeleteTag={handleDeleteTag}
                        onValidateLabel={vailidateLabel}
                        onChangeVariant={handleChangeVariant}
                        getI18n={getI18n}
                      />
                    ) : null}

                    {isVirtual && <VirtualStock products={products} />}
                    {isVirtual &&
                      services.map((service) => {
                        const { uuid, sku, name } = service;
                        return (
                          <ServiceDetail
                            title={`${name} ${sku}`}
                            isOnPrimaryLanguage={isOnPrimaryLanguage}
                            termsAndConditionList={termsAndConditionList}
                            uuid={uuid}
                            key={service.uuid}
                            disabled={!canCreate}
                            handleChangeServiceOptions={
                              handleChangeServiceOptions
                            }
                            handleChangePlaceholder={handleChangePlaceholder}
                            handleChangeTitle={handleChangeTitle}
                            productUuid={service.uuid}
                            handleOnDetailsTcChange={handleOnDetailsTcChange}
                            services={
                              (productService[uuid] || {}).serviceDetails || []
                            }
                            termsAndConditions={
                              (productService[uuid] || {}).termsConditions || []
                            }
                          />
                        );
                      })}
                    <SubscriptionBuy data={subscriptionBuyProducts || []} />
                    <Stock products={products} />
                    {isVirtual && (
                      <Logistic
                        products={products}
                        logistics={productLogistics}
                        disabled={!canCreate}
                        onLogisticNotifyChange={handleLogisticNotifyChange}
                        onLogisticEmailChange={handleLogisticEmailChange}
                        onLogisticSmsChange={handleLogisticSmsChange}
                      />
                    )}
                  </>
                )}
              </>
            )}
            {!isOnPrimaryLanguage && (
              <>
                <div className={styles.clone}>
                  <Button
                    type='primary'
                    onClick={handleCloneOptions}
                    disabled={!canCreate}>
                    {getI18n('general.cloneBtn.error_title')}
                  </Button>
                </div>
                {isVirtual &&
                  services.map((service) => {
                    const { uuid, sku, name } = service;
                    return (
                      <ServiceDetail
                        title={`${name} ${sku}`}
                        isOnPrimaryLanguage={isOnPrimaryLanguage}
                        uuid={uuid}
                        termsAndConditionList={termsAndConditionList}
                        key={service.uuid}
                        disabled={!canCreate}
                        handleChangeServiceOptions={handleChangeServiceOptions}
                        handleChangePlaceholder={handleChangePlaceholder}
                        handleChangeTitle={handleChangeTitle}
                        productUuid={service.uuid}
                        handleOnDetailsTcChange={handleOnDetailsTcChange}
                        services={
                          (productService[uuid] || {}).serviceDetails || []
                        }
                        termsAndConditions={
                          (productService[uuid] || {}).termsConditions || []
                        }
                      />
                    );
                  })}
                {isPhysical && products.length > 1 && (
                  <SecondaryOptions
                    originalOptions={options}
                    options={optionsForMultiLang}
                    disabled={!canCreate}
                    handleChangeLabel={handleMLChangeLabel}
                    handleChangeValue={handleMLChangeValue}
                  />
                )}
              </>
            )}
            <Skeleton active loading={isLoading}>
              <PromotionTag
                isPrimary={isOnPrimaryLanguage}
                data={allPromotionTags}
                disabled={!canCreate}
                onChange={handleOnAllPromotionTags}
              />
            </Skeleton>

            <Warning
              visible={deleteModalVisible}
              header={getI18n('salesChannelProductDetail.index.deleteProducts')}
              onOk={handleDelete}
              okText={getI18n('general.delete')}
              cancelText={getI18n('general.cancel')}
              onCancel={handleHideWarning}>
              {getI18n(
                'salesChannelProductDetail.index.areyousuretodeletethisproduct',
              )}
            </Warning>

            <Warning
              visible={deleteOptionIndex !== -1}
              header={getI18n('salesChannelProductDetail.index.deleteoption')}
              onOk={delOption.bind(null, deleteOptionIndex)}
              okText={getI18n('general.delete')}
              cancelText={getI18n('general.cancel')}
              onCancel={handleHideOptionDelete}>
              {getI18n('salesChannelProductDetail.index.suretodelete')}
            </Warning>

            {addModalVisible && (
              //salesChannelCurrency
              <TypedProductsSelection
                // fixedSearchConditions={{ currency: salesChannelCurrency }}
                visible={addModalVisible}
                onCancel={handleHide}
                onOk={handleAddProduct}
                selectedItems={products}
                selectType={SelectionType.Typed}
                selectedProductsProperty={
                  products.length === 0
                    ? null
                    : isVirtual
                    ? EnumProductProperty.Virtual
                    : EnumProductProperty.Physical
                }
                fixedSearchConditions={{
                  listPriceEnabled: true,
                  currency: salesChannelCurrency,
                  salesChannelUuid: saleChannelUuid,
                }}
                extraProps={{ keepData: true }}
                // extraProps={{ keepData: true }}
              />
            )}
          </div>
        ) : (
          <div className={styles.content}>
            {getI18n('general.permission.permissiondenied')}
          </div>
        )}
      </Form>
    </div>
  );
}

export default SalesChannelHOC(SelectHOC(SalesChannelProductsLinkProduct), {
  type: EnumMultiLanguageType.SalesChannelProduct,
  saleChannelUuidKey: 'saleChannelUuid',
});
